// Angular import
import { Component, Input } from '@angular/core';

// Project import
import { NavigationItem } from 'src/app/@theme/types/navigation';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  // public props
  @Input() item!: NavigationItem;


  // ngAfterViewInit() {
  //   console.log('MenuItemComponent initialized with item:', this.item);
  // }

  // Constructor
  constructor(private layoutService: ThemeLayoutService, private _router: Router) { }

  // public method

  toggleMenu(event: MouseEvent) {
    // this.openInNewTab(event);
    if (window.innerWidth < 1025) {
      this.layoutService.toggleSideDrawer();
    }
    const ele = event.target as HTMLElement;
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement as HTMLElement;
      const up_parent = ((parent.parentElement as HTMLElement).parentElement as HTMLElement).parentElement as HTMLElement;
      const last_parent = up_parent.parentElement;
      const sections = document.querySelectorAll('.coded-hasmenu');
      for (let i = 0; i < sections.length; i++) {
        sections[i].classList.remove('active');
        sections[i].classList.remove('coded-trigger');
      }

      if (parent.classList.contains('coded-hasmenu')) {
        parent.classList.add('coded-trigger');
        parent.classList.add('active');
      } else if (up_parent.classList.contains('coded-hasmenu')) {
        up_parent.classList.add('coded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('coded-hasmenu')) {
        last_parent.classList.add('coded-trigger');
        last_parent.classList.add('active');
      }
    }
  }

  openInNewTab(event: MouseEvent): void {
    if (this.isExternal(this.item.url)) return;

    event.preventDefault();
    const url = this._router.serializeUrl(
      this._router.createUrlTree([this.item.url])
    );
    const fullUrl = window.location.origin + url;
    window.open(fullUrl, '_blank');
  }

  isExternal(link: string): boolean {
    return /^(http|https|mailto|tel):/.test(link);
  } // Check if the link is external or angular route
}
